var _mask, _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEyeOpen = function SvgEyeOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 24,
    fill: "none"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "eye-open_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.076 12c.833-4.534 5.38-8 10.864-8s10.031 3.466 10.864 8c-.833 4.534-5.38 8-10.864 8S2.91 16.534 2.076 12",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M2.076 12 .11 11.639.043 12l.066.361zm21.728 0 1.967.361.066-.361-.066-.361zm-19.76.361C4.669 8.958 8.224 6 12.94 6V2C6.687 2 1.15 5.974.11 11.639zM12.94 6c4.716 0 8.272 2.958 8.897 6.361l3.934-.722C24.73 5.974 19.193 2 12.94 2zm8.897 5.639C21.212 15.042 17.656 18 12.94 18v4c6.253 0 11.79-3.974 12.83-9.639zM12.94 18c-4.716 0-8.271-2.958-8.896-6.361l-3.935.722C1.15 18.026 6.687 22 12.94 22z",
    mask: "url(#eye-open_svg__a)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.94,
    cy: 12,
    r: 3,
    stroke: "#000",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.94 1h2v4h-2zM.607 9.731l.518-1.932L4.99 8.834l-.518 1.932zM24.755 7.798l.518 1.932-3.864 1.036-.518-1.932zM5.146 3.485l1.587-1.218 2.74 3.57-1.588 1.218zM19.148 2.268l1.586 1.218-2.74 3.57-1.586-1.218z"
  })));
};
export default SvgEyeOpen;